import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LangContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useTranslation } from '@aarhus-university/au-lib-react-components/src/lib/hooks';
import ForgotPasswordComponent from '../components/forgot-password/ForgotPasswordComponent';
import SetPasswordComponent from '../components/forgot-password/SetPasswordComponent';
import UsernameForgotComponent from '../components/forgot-username/ForgetUsernameComponent';
import { defaultLabels, importJson, TranslationsContext } from '../lib/translation';

declare global {
  interface Window {
    appLang: string,
  }
}

const ForgotPasswordWrapperComponent: FC = () => {
  const lang = window.appLang;
  const translations = useTranslation<IPasswordTranslation>(defaultLabels, [importJson('password', lang), null], lang);
  // parse userToken from URL
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('userToken') || null;
  const contextKey = urlParams.get('context') || null;
  return (
    <LangContext.Provider value={lang}>
      <TranslationsContext.Provider value={translations}>
        <Routes>
          <Route path={`${lang}/password/forgot`} element={<ForgotPasswordComponent contextKey={contextKey} />} />
          <Route path={`${lang}/password/new`} element={<SetPasswordComponent token={token} />} />
          <Route path={`${lang}/user/forgot`} element={<UsernameForgotComponent />} />
        </Routes>
      </TranslationsContext.Provider>
    </LangContext.Provider>
  );
};

ForgotPasswordWrapperComponent.displayName = 'ForgotPasswordWrapperComponent';
export default ForgotPasswordWrapperComponent;
